import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";

import dialogSkin from "../skin/common/dialog.skin";

const useStyles = createUseStyles(dialogSkin);

const DialogHeader = ({ title, onClose }) => {
  const classes = useStyles();

  return (
    <div className={classes["dialog-header"]}>
      <h5 className={classes["dialog-title"]}>{title}</h5>
      <button
        type="button"
        className={classes["dialog-close-button"]}
        aria-label="Close"
        onClick={onClose}
      />
    </div>
  );
};

DialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DialogHeader;
